// extracted by mini-css-extract-plugin
export var messageSideLeft = "_mz-1";
export var messageSideRight = "_mz-2";
export var orderLookupBubbleContainer = "_mz-0";
export var submitButton = "_mz-3";